export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const LOGIN = "login";

export const REGISTER = "/register";

export const RELATIONS = "/relations";

export const DOCUMENT_SELECT = "/proof-of-identify";

export const KYC = "/kyc";

export const MembershipPlans = "membership-plans";

export const deleteTransaction = `${BASE_URL}/membership-application-by-transaction`;

export const HTTP = process.env.REACT_APP_HTTP;

/** GET /receipts/:enrollId — receipt data for PDF download */
export const RECEIPT_BY_ENROLL_ID = (enrollId) => `/receipts/${enrollId}`;
